import * as THREE from 'three';

import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';
export const lineMaterialModel = [
    new LineMaterial({
        color: 0xFFFFFF,
        linewidth: 0.014,
        vertexColors: false,
        dashed: false,
        alphaToCoverage: true,
        worldUnits: true,
    }),
    new LineMaterial({
        color: 0x0000FF,
        linewidth: 0.014,
        vertexColors: false,
        dashed: false,
        alphaToCoverage: true,
        worldUnits: true,
    }),
    new LineMaterial({
        color: 0xFFFF00,
        linewidth: 0.014,
        vertexColors: false,
        dashed: false,
        alphaToCoverage: true,
        worldUnits: true,
    }),
    new LineMaterial({
        color: 0xFF0000,
        linewidth: 0.014,
        vertexColors: false,
        dashed: false,
        alphaToCoverage: true,
        worldUnits: true,
    }),
    new LineMaterial({
        color: 0x22CF22,
        linewidth: 0.016,
        vertexColors: false,
        dashed: false,
        alphaToCoverage: true,
        worldUnits: true,
    }),
];

export const lineMaterialImage = [
    new LineMaterial({
        color: 0xFFFFFF,
        linewidth: 3,
        vertexColors: false,
        dashed: false,
        alphaToCoverage: true,
        worldUnits: false,
        depthTest: false,
    }),
    new LineMaterial({
        color: 0x0000FF,
        linewidth: 3,
        vertexColors: false,
        dashed: false,
        alphaToCoverage: true,
        worldUnits: false,
        depthTest: false,
    }),
    new LineMaterial({
        color: 0xFFFF00,
        linewidth: 3,
        vertexColors: false,
        dashed: false,
        alphaToCoverage: true,
        worldUnits: false,
        depthTest: false,
    }),
    new LineMaterial({
        color: 0xFF0000,
        linewidth: 3,
        vertexColors: false,
        dashed: false,
        alphaToCoverage: true,
        worldUnits: false,
        depthTest: false,
    }),
    new LineMaterial({
        color: 0x22CF22,
        linewidth: 3,
        vertexColors: false,
        dashed: false,
        alphaToCoverage: true,
        worldUnits: false,
        depthTest: false,
    }),
];

function createMarkerTexture(): THREE.CanvasTexture {
    const size = 32;
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const context = canvas.getContext('2d');
    if (context) {
        context.clearRect(0, 0, size, size);
        context.beginPath();
        context.arc(size / 2, size / 2, size * 0.32, 0, Math.PI * 2);
        context.fillStyle = '#ffffff';
        context.fill();
        context.lineWidth = 3;
        context.strokeStyle = '#000000';
        context.stroke();
    }
    const texture = new THREE.CanvasTexture(canvas);
    texture.needsUpdate = true;
    return texture;
}

const markerTexture = createMarkerTexture();

export const markerMaterialImage = [
    0xFFFFFF,
    0x0000FF,
    0xFFFF00,
    0xFF0000,
    0x22CF22,
].map((color) => new THREE.PointsMaterial({
    color,
    size: 12,
    sizeAttenuation: false,
    map: markerTexture,
    transparent: true,
    alphaTest: 0.1,
    depthTest: false,
    depthWrite: false,
}));
